import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { ClientesService} from  '../services/api/cadastros/ClientesService';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';


type TAutoCompleteOption = {
  idcli: string;
  label: string;
}

interface IAutoCompleteClienteProps {
  isExternalLoading?: boolean;
  uuidcli?: (novoTextoselect: string | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompleteCliente: React.FC<IAutoCompleteClienteProps> = ({ isExternalLoading = false, uuidcli, nome }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idcli');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {  
      ClientesService.getAllList(selectedId, busca)
        .then((result) => {
          setIsLoading(false); 

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(cliente => ({ idcli: cliente.idcli, label: cliente.nome })));
          }
        }); 
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idcli === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idcli); uuidcli?.(newValue?.idcli); nome?.(newValue?.label); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small' 
          label="Cliente"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};